import type { ReactNode } from 'react';
import { type NavigateFunction, useNavigate } from 'react-router-dom';

let navigate: NavigateFunction = () => {
  assert(false, 'Attempted history nav before init!');
};

/** Lets code outside React (sagas, Bugsnag) navigate. Mount it inside the router. */
export function NavigateSetter({ children }: { children?: ReactNode }): ReactNode {
  navigate = useNavigate();

  return children;
}

export default NavigateSetter;

export { navigate };
